import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';

import { NOT_FOUND_404, ONBOARDING_BASE_ROUTE, SIGNUP_ROUTE } from './shared/services/router-link-creator.service';

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./static-pages/home-page-redirecter/home-page-redirecter.module').then(m => m.HomePageRedirecterModule)
  },
  {
    path: 'home-page',
    loadChildren: () => import('./static-pages/home-page-redirecter/home-page-redirecter.module').then(m => m.HomePageRedirecterModule)
  },
  {
    path: 'sign-in',
    loadChildren: () => import('./static-pages/sign-in-redirecter/sign-in-redirecter.module').then(m => m.SignInRedirecterModule)
  },
  {
    path: 'business-esg',
    redirectTo: 'business'
  },
  {
    path: 'newsfeed',
    loadChildren: () => import('./newsfeed/newsfeed.module').then(m => m.NewsfeedModule)
  },
  {
    path: 'sustainability-profile',
    loadChildren: () => import('./static-pages/sustainability-profile/sustainability-profile.module').then(m => m.SustainabilityProfileModule)
  },
  {
    path: ONBOARDING_BASE_ROUTE,
    redirectTo: SIGNUP_ROUTE
  },
  {
    path: SIGNUP_ROUTE,
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'activity',
    loadChildren: () => import('./activity/activity.module').then(m => m.ActivityModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./search/search.module').then(m => m.SearchModule)
  },
  {
    path: 'ranks',
    loadChildren: () => import('./ranks/ranks.module').then(m => m.RanksModule)
  },
  {
    path: 'blog',
    loadChildren: () => import('./media/media.module').then(m => m.MediaModule)
  },
  {
    path: 'media',
    redirectTo: 'blog'
  },
  {
    path: 'security-policy',
    loadComponent: () => import('./static-pages/security-policy/security-policy.component').then(c => c.SecurityPolicyComponent)
  },
  {
    path: 'faq',
    loadChildren: () => import('./static-pages/faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./static-pages/terms/terms.module').then(m => m.TermsModule)
  },

  {
    path: 'knowledge-base',
    loadChildren: () => import('./static-pages/knowledge-base/knowledge-base.module').then(m => m.KnowledgeBaseModule)
  },
  {
    path: 'notable-mentions',
    loadChildren: () => import('./static-pages/notable-mentions/notable-mentions.module').then(m => m.NotableMentionsModule)
  },
  {
    path: 'cookie-policy',
    loadChildren: () => import('./static-pages/cookie-policy/cookie-policy.module').then(m => m.CookiePolicyModule)
  },
  {
    path: 'billing-info',
    loadChildren: () => import('./static-pages/billing-info/billing-info.module').then(m => m.BillingInfoModule)
  },
  {
    path: 'sign-in-required',
    loadChildren: () => import('./static-pages/sign-in-required/sign-in-required.module').then(m => m.SignInRequiredModule)
  },
  {
    path: NOT_FOUND_404,
    loadChildren: () => import('./static-pages/not-found/not-found.module').then(m => m.NotFoundModule)
  },
  {
    path: 'unsubscribe',
    loadChildren: () => import('./unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule)
  },
  {
    path: 'lock-screen',
    loadComponent: () =>
      import('./static-pages/lock-screen/containers/lock-screen-container/lock-screen-container.component').then(m => m.LockScreenContainerComponent)
  },
  {
    path: '**',
    redirectTo: NOT_FOUND_404
  }
];

const languageRoutes: Routes = [
  {
    path: 'gb',
    children: appRoutes
  },
  {
    path: 'en',
    children: appRoutes
  },
  {
    path: 'sk',
    children: appRoutes
  },
  {
    path: 'cs',
    children: appRoutes
  },
  {
    path: 'de',
    children: appRoutes
  },
  {
    path: 'es',
    children: appRoutes
  },
  {
    path: 'sl',
    children: appRoutes
  },
  {
    path: 'pl',
    children: appRoutes
  },
  {
    path: 'ar',
    children: appRoutes
  },
  {
    path: 'pt',
    children: appRoutes
  },
  {
    path: 'hu',
    children: appRoutes
  },
  {
    path: '',
    children: appRoutes
  }
];

/**
 * Router module - main application routing.
 */
@NgModule({
  imports: [
    RouterModule.forRoot(languageRoutes, {
      preloadingStrategy: NoPreloading,
      scrollPositionRestoration: 'enabled',
      bindToComponentInputs: true,
      defaultQueryParamsHandling: 'merge'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
